import {useEffect, useState} from "react";
import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { t } from "i18next";
import "./selectMore.css";

const ITEM_HEIGHT = 58;

export default function SelectMore({ options, openModal, handleOpenModal }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    handleClose();
  }, [openModal]);

  return (
     <>
       <IconButton
          aria-label="more"
          id="long-button"
          aria-controls={open ? 'long-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-haspopup="true"
          onClick={handleClick}
       >
         <MoreVertIcon />
       </IconButton>
       <Menu
          id="long-menu"
          MenuListProps={{
            'aria-labelledby': 'long-button',
          }}
          className="select-more"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          PaperProps={{
            style: {
              maxHeight: ITEM_HEIGHT * 4.5,
              width: '20ch',
            },
          }}
       >
         {options.map((option) => (
            <MenuItem key={option.value} onClick={() => handleOpenModal(option.value)}>
              {t(option.name)}
            </MenuItem>
         ))}
       </Menu>
     </>
  );
}